import { checkNullDate } from "../../exports/functions";
import {
  IAddress,
  ICooperativeDetails,
  IDeclaration,
  IDocumentsInput,
  IFinancialAuditInput,
  IFinancialIncome,
  IFinancialLoan,
  IFinancialShare,
  IFinancialTax,
  IShareMemberInput,
} from "../../exports/interfaces";

export const getRegisterFormInitialState = (
  initialData?: ICooperativeDetails | null,
) => {
  const responseData = initialData as any;

  const rawOtherDoc = responseData?.documents?.otherDocumentUrl;
  const initialOtherUrls: string[] = Array.isArray(rawOtherDoc)
    ? rawOtherDoc
    : typeof rawOtherDoc === "string" && rawOtherDoc.trim()
    ? [rawOtherDoc]
    : [];

  return {
    cooperativeInfo: {
      registrationNumber: initialData?.registrationNumber ?? "",
      businessregistrationNumber: initialData?.businessregistrationNumber ?? "",
      nameNepali: initialData?.nameNepali ?? "",
      nameEnglish: initialData?.nameEnglish ?? "",
      natureOfWork: initialData?.natureOfWork ?? "",
      workingArea: initialData?.workingArea ?? "",
      panNumber: initialData?.panNumber ?? "",
      email: initialData?.email ?? "",
      mobileNumber: initialData?.mobileNumber ?? "",
      contactPerson: initialData?.contactPerson ?? "",
      registeredDate: initialData?.registeredDate ?? "",
      registeredEnglishDate:
        checkNullDate(initialData?.registeredEnglishDate) ?? "",
      registeredAt: initialData?.registeredAt ?? "",
      registeredOfficeAddress: initialData?.registeredOfficeAddress ?? "",
      isRegisteredInFederation: initialData?.isRegisteredInFederation ?? null,
      womenLead: initialData?.womenLead ?? null,
      staffCount: initialData?.staffCount ?? null,
      softwareUsed: initialData?.softwareUsed ?? "",
      maleMembers: initialData?.maleMembers ?? null,
      femaleMembers: initialData?.femaleMembers ?? null,
      otherMembers: initialData?.otherMembers ?? null,
      status: initialData?.status ?? "",
      mergedCooperativeName: initialData?.mergedCooperativeName ?? "",
      mergedDateNepali: initialData?.mergedDateNepali ?? "",
      mergedDateEnglish: checkNullDate(initialData?.mergedDateEnglish) ?? "",
      mergeReason: initialData?.mergeReason ?? "",
      closeDateNepali: initialData?.closeDateNepali ?? "",
      closeDateEnglish: checkNullDate(initialData?.closeDateEnglish) ?? "",
    } as ICooperativeDetails,
    address: {
      province: initialData?.address?.province ?? "",
      district: initialData?.address?.district ?? "",
      municipality: initialData?.address?.municipality ?? "",
      streetTole: initialData?.address?.streetTole ?? "",
      ward: initialData?.address?.ward ?? "",
    } as IAddress,
    shareFinancial: {
      fiscalYear: responseData?.financial?.share?.fiscalYear ?? "",
      maleMembers: responseData?.financial?.share?.maleMembers,
      femaleMembers: responseData?.financial?.share?.femaleMembers,
      otherMembers: responseData?.financial?.share?.otherMembers,

      institutionalMembers:
        responseData?.financial?.share?.institutionalMembers,
      totalShareMembers: responseData?.financial?.share?.totalShareMembers,
      totalGeneralSaving:
        responseData?.financial?.share?.totalGeneralSaving ?? "",
      totalRegularSaving:
        responseData?.financial?.share?.totalRegularSaving ?? "",
      totalPeriodicSaving:
        responseData?.financial?.share?.totalPeriodicSaving ?? "",
      totalSavingAmount:
        responseData?.financial?.share?.totalSavingAmount ?? "",
      femaleDepositors: responseData?.financial?.share?.femaleDepositors ?? "",
      maleDepositors: responseData?.financial?.share?.maleDepositors ?? "",
      otherDepositors: responseData?.financial?.share?.otherDepositors ?? "",
      totalDepositors: responseData?.financial?.share?.totalDepositors ?? "",
      balanceSheet: responseData?.financial?.share?.balanceSheet ?? "",
      totalLiabilities: responseData?.financial?.share?.totalLiabilities ?? "",
      totalAssets: responseData?.financial?.share?.totalAssets ?? "",
      totalLiquidAssets:
        responseData?.financial?.share?.totalLiquidAssets ?? "",
      tlaToTaRatio: responseData?.financial?.share?.tlaToTaRatio ?? "",
      cash: responseData?.financial?.share?.cash ?? "",
      association: responseData?.financial?.share?.association ?? "",
      districtUnion: responseData?.financial?.share?.districtUnion ?? "",
      bank: responseData?.financial?.share?.bank ?? "",
    } as IFinancialShare,
    loanFinancial: {
      fiscalYear: responseData?.financial?.loan?.fiscalYear ?? "",
      totalShareCapital: responseData?.financial?.loan?.totalShareCapital ?? "",
      totalReserveFund: responseData?.financial?.loan?.totalReserveFund ?? "",
      deficitReplenishmentFund:
        responseData?.financial?.loan?.deficitReplenishmentFund ?? "",
      accumulatedProfitLoss:
        responseData?.financial?.loan?.accumulatedProfitLoss ?? "",
      coreCapital: responseData?.financial?.loan?.coreCapital ?? "",
      totalPassLoan: responseData?.financial?.loan?.totalPassLoan ?? "",
      totalSubStandardLoan:
        responseData?.financial?.loan?.totalSubStandardLoan ?? "",
      totalDoubtfulLoan: responseData?.financial?.loan?.totalDoubtfulLoan ?? "",
      totalLossLoan: responseData?.financial?.loan?.totalLossLoan ?? "",
      totalLoanDisbursed:
        responseData?.financial?.loan?.totalLoanDisbursed ?? "",
      externalLoan: responseData?.financial?.loan?.externalLoan ?? "",
      maleBorrowers: responseData?.financial?.loan?.maleBorrowers ?? "",
      femaleBorrowers: responseData?.financial?.loan?.femaleBorrowers ?? "",
      othersBorrowers: responseData?.financial?.loan?.othersBorrowers ?? "",
      totalBorrowers: responseData?.financial?.loan?.totalBorrowers ?? "",
      llpPassLoan: responseData?.financial?.loan?.llpPassLoan ?? "",
      llpSubStandardLoan:
        responseData?.financial?.loan?.llpSubStandardLoan ?? "",
      llpDoubtfulLoan: responseData?.financial?.loan?.llpDoubtfulLoan ?? "",
      llpLossLoan: responseData?.financial?.loan?.llpLossLoan ?? "",
      totalLoanLossProvision:
        responseData?.financial?.loan?.totalLoanLossProvision ?? "",
      additionalProvisionLoanLoss:
        responseData?.financial?.loan?.additionalProvisionLoanLoss ?? "",
      assetsRevaluationReserve:
        responseData?.financial?.loan?.assetsRevaluationReserve ?? "",
      freeReserve: responseData?.financial?.loan?.freeReserve ?? "",
      supplementaryCapital:
        responseData?.financial?.loan?.supplementaryCapital ?? "",
      totalCapitalFund: responseData?.financial?.loan?.totalCapitalFund ?? "",
      totalNonPerformingLoan:
        responseData?.financial?.loan?.totalNonPerformingLoan ?? "",
      nplPercentage: responseData?.financial?.loan?.nplPercentage ?? "",
      totalRiskWeightedAssets:
        responseData?.financial?.loan?.totalRiskWeightedAssets ?? "",
      coreCapitalRatio: responseData?.financial?.loan?.coreCapitalRatio ?? "",
      totalCapitalFundRatio:
        responseData?.financial?.loan?.totalCapitalFundRatio ?? "",
      totalBorrowing: responseData?.financial?.loan?.totalBorrowing ?? "",
      loanRescheduledCount: responseData?.financial?.loan?.loanRescheduledCount,
      loanRescheduledAmount:
        responseData?.financial?.loan?.loanRescheduledAmount ?? "",
      investmentPrivateLtd:
        responseData?.financial?.loan?.investmentPrivateLtd ?? "",
      investmentHouseBuilding:
        responseData?.financial?.loan?.investmentHouseBuilding ?? "",
    } as IFinancialLoan,
    incomeFinancial: {
      fiscalYear: responseData?.financial?.income?.fiscalYear ?? "",
      operationalIncome:
        responseData?.financial?.income?.operationalIncome ?? "",
      otherIncome: responseData?.financial?.income?.otherIncome ?? "",
      operationalExpenses:
        responseData?.financial?.income?.operationalExpenses ?? "",
      otherExpenses: responseData?.financial?.income?.otherExpenses ?? "",
      netProfitLoss: responseData?.financial?.income?.netProfitLoss ?? "",
    } as IFinancialIncome,
    auditFinancial: {
      fiscalYear: responseData?.financial?.audit?.fiscalYear ?? "",
      auditorName: responseData?.financial?.audit?.auditorName ?? "",
      auditorMobile: responseData?.financial?.audit?.auditorMobile ?? "",
      auditorAddress: responseData?.financial?.audit?.auditorAddress ?? "",
      icanNumber: responseData?.financial?.audit?.icanNumber ?? "",
      agmDate: checkNullDate(responseData?.financial?.audit?.agmDate) ?? "",
      agmNepaliDate: responseData?.financial?.audit?.agmNepaliDate ?? "",
      participants: responseData?.financial?.audit?.participants,
      participantsAttended:
        responseData?.financial?.audit?.participantsAttended,
      participantsPercent:
        responseData?.financial?.audit?.participantsPercent ?? "",
      file: null,
      fileName: "",
      documentUrl: responseData?.financial?.audit?.documentUrl ?? "",
    } as IFinancialAuditInput,
    taxFinancial: {
      fiscalYear: responseData?.financial?.tax?.fiscalYear ?? "",
      incomeTax: responseData?.financial?.tax?.incomeTax ?? "",
      interestTax: responseData?.financial?.tax?.interestTax ?? "",
      employeeTax: responseData?.financial?.tax?.employeeTax ?? "",
      taxOthers: responseData?.financial?.tax?.taxOthers ?? "",
      serviceTax: responseData?.financial?.tax?.serviceTax ?? "",
      rentalTax: responseData?.financial?.tax?.rentalTax ?? "",
      localOthers: responseData?.financial?.tax?.localOthers ?? "",
    } as IFinancialTax,
    committeeTableCooperative:
      responseData?.cooperativeandexecutive?.committeemember?.map(
        (item: any) => ({
          id: item.id,
          fiscalYear: item.fiscalYear,
          committeeType: item.committeeType,
          position: item.position,
          positionStatus: item.positionStatus,
          grandmotherName: item.grandmotherName,
          fatherName: item.fatherName,
          maritalStatus: item.maritalStatus ?? "",
          husbandName: item.husbandName,
          fullName: item.fullName,
          gender: item.gender,
          mobile: item.mobile,
          email: item.email,
          address: item.address,
          citizenship: item.citizenship,
          pan: item.pan,
          nid: item.nid,
          issuedDistrict: item.issuedDistrict,
          tenureStart: checkNullDate(item.tenureStart),
          tenureEnd: checkNullDate(item.tenureEnd),
          province: item.province,
          district: item.district,
          municipality: item.municipality,
          ward: item.ward,
          street: item.street,
          education: item.education,
          file: null,
          fileName: "",
          documentUrl: item.photoUrl,
          bodFile: null,
          bodFileName: "",
          citizenshipFront: null,
          citizenshipFrontName: "",
          citizenshipFrontUrl:
            item.citizenshipFrontUrl ?? item.CitizenshipFrontUrl ?? "",
          citizenshipBack: null,
          citizenshipBackName: "",
          citizenshipBackUrl:
            item.citizenshipBackUrl ?? item.CitizenshipBackUrl ?? "",
          bodDocumentUrl: item.bodDocumentUrl,
        }),
      ) ?? [],
    executiveTableCooperative:
      responseData?.cooperativeandexecutive?.executivemember?.map(
        (item: any) => ({
          id: item.id,
          fiscalYear: item.fiscalYear,
          position: item.position,
          positionStatus: item.positionStatus,
          grandmotherName: item.grandmotherName,
          fatherName: item.fatherName,
          maritalStatus: item.maritalStatus ?? "",
          husbandName: item.husbandName,
          fullName: item.fullName,
          gender: item.gender,
          mobile: item.mobile,
          email: item.email,
          address: item.address,
          pan: item.pan,
          nid: item.nid,
          citizenship: item.citizenship,
          issuedDistrict: item.issuedDistrict,
          province: item.province,
          district: item.district,
          municipality: item.municipality,
          ward: item.ward,
          street: item.street,
          experience: item.experience,
          currentPositionDuration: item.currentPositionDuration,
          education: item.education,
          file: null,
          fileName: "",
          citizenshipFront: null,
          citizenshipFrontName: "",
          citizenshipFrontUrl:
            item.citizenshipFrontUrl ?? item.CitizenshipFrontUrl ?? "",
          citizenshipBack: null,
          citizenshipBackName: "",
          citizenshipBackUrl:
            item.citizenshipBackUrl ?? item.CitizenshipBackUrl ?? "",
          documentUrl: item.photoUrl,
        }),
      ) ?? [],
    shareMember: {
      shareMemberFile: null,
      shareMemberFileName: "",
      shareMemberDocumentUrl: responseData?.shareMember?.shareMemberUrl ?? "",
      shareMaleMembers: responseData?.shareMember?.shareMaleMembers ?? "",
      shareFemaleMembers: responseData?.shareMember?.shareFemaleMembers ?? "",
      shareOthersMembers: responseData?.shareMember?.shareOthersMembers ?? "",
      shareTotalMembers: responseData?.shareMember?.shareTotalMembers ?? "",
      savingMemberFile: null,
      savingMemberFileName: "",
      savingMemberDocumentUrl: responseData?.shareMember?.savingMemberUrl ?? "",
      savingMaleMembers: responseData?.shareMember?.savingMaleMembers ?? "",
      savingFemaleMembers: responseData?.shareMember?.savingFemaleMembers ?? "",
      savingOthersMembers: responseData?.shareMember?.savingOthersMembers ?? "",
      savingTotalMembers: responseData?.shareMember?.savingTotalMembers ?? "",
      loanMemberFile: null,
      loanMemberFileName: "",
      loanMemberDocumentUrl: responseData?.shareMember?.loanMemberUrl ?? "",
      loanMaleMembers: responseData?.shareMember?.loanMaleMembers ?? "",
      loanFemaleMembers: responseData?.shareMember?.loanFemaleMembers ?? "",
      loanOthersMembers: responseData?.shareMember?.loanOthersMembers ?? "",
      loanTotalMembers: responseData?.shareMember?.loanTotalMembers ?? "",
    } as IShareMemberInput,
    documents: {
      regCertificateFile: null,
      regCertificateFileName: "",
      regCertificateDocumentUrl:
        responseData?.documents?.regCertificateUrl ?? "",
      lawDocumentFile: null,
      lawDocumentFileName: "",
      lawDocumentDocumentUrl: responseData?.documents?.lawDocumentUrl ?? "",
      foundingDocumentFile: null,
      foundingDocumentFileName: "",
      foundingDocumentDocumentUrl:
        responseData?.documents?.foundingDocumentUrl ?? "",
      panDocumentFile: null,
      panDocumentFileName: "",
      panDocumentDocumentUrl: responseData?.documents?.panDocumentUrl ?? "",
      businessRegistrationFile: null,
      businessRegistrationFileName: "",
      businessRegistrationDocumentUrl:
        responseData?.documents?.businessRegistrationUrl ?? "",
      taxClearanceFile: null,
      taxClearanceFileName: "",
      taxClearanceDocumentUrl: responseData?.documents?.taxClearanceUrl ?? "",
      meetingDocumentFile: null,
      meetingDocumentFileName: "",
      meetingDocumentDocumentUrl:
        responseData?.documents?.meetingDocumentUrl ?? "",
      agmDocumentFile: null,
      agmDocumentFileName: "",
      agmDocumentDocumentUrl: responseData?.documents?.agmDocumentUrl ?? "",
      otherDocumentFiles: [],
      otherDocumentFileNames: [],
      otherDocumentDocumentUrls: initialOtherUrls,
      otherDocumentFile: null,
      otherDocumentFileName: "",
      otherDocumentDocumentUrl: initialOtherUrls[0] || "",
    } as IDocumentsInput,
    declaration: {
      name: responseData?.declaration?.name ?? "",
      position: responseData?.declaration?.position ?? "",
      mobile: responseData?.declaration?.mobile ?? "",
      declaration: responseData?.declaration?.declaration ?? "",
    } as IDeclaration,
  };
};
